import { api } from './client';

export interface UserEntry {
  username: string;
  uid: number;
  managed: boolean;
  name?: string;
  email?: string;
  created_at?: string;
}

export interface CreateUserPayload {
  username: string;
  name: string;
  email: string;
  password?: string;
}

export const fetchUsers = (): Promise<UserEntry[]> =>
  api.get<{ users: UserEntry[] }>('/users').then((r) => r.data.users);

export const createUser = (payload: CreateUserPayload): Promise<{ username: string }> =>
  api.post<{ username: string }>('/users', payload).then((r) => r.data);

export const deleteUser = (username: string): Promise<void> =>
  api.delete(`/users/${username}`).then(() => undefined);

export const setUserPassword = (username: string, password: string): Promise<void> =>
  api.post(`/users/${username}/password`, { password }).then(() => undefined);
